export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        affiliateTrainingSteps: action.affiliateTrainingSteps,
      };

    case 'CREATE':
      return {
        ...state,
        affiliateTrainingSteps: [...state.affiliateTrainingSteps, action.affiliateTrainingStep],
      };

    case 'UPDATE':
      return {
        ...state,
        affiliateTrainingSteps: state.affiliateTrainingSteps.map(
          (step) => (step.id === action.affiliateTrainingStep.id ? action.affiliateTrainingStep : step),
        ),
      };

    case 'SORT':
      return {
        ...state,
        affiliateTrainingSteps: action.affiliateTrainingSteps,
      };

    case 'DESTROY':
      return {
        ...state,
        affiliateTrainingSteps: state.affiliateTrainingSteps.filter(
          (step) => step.id !== action.affiliateTrainingStepId,
        ),
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
